import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Navigation = ({ appMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const getActiveClass = (path) => {
    const currentPath = location.pathname === '/' ? '/marketplace' : location.pathname;
    if (path === '/properties' && currentPath.startsWith('/properties')) return 'bg-emerald-600 text-white';
    return currentPath === path ? 'bg-emerald-600 text-white' : 'bg-white hover:bg-gray-100';
  };

  const isAgentOrOwner = appMode === 'Agent' || appMode === 'Private Owner';
  const isInfluencer = appMode === 'Influencer';
  const isContractor = appMode === 'Contractor';

  return (
    <nav className="bg-gray-50 shadow-inner border-b">
      <div className="max-w-7xl mx-auto px-4 py-2 flex gap-2 overflow-x-auto">
        <Button
          variant="ghost"
          data-testid="nav-marketplace"
          className={`whitespace-nowrap ${getActiveClass('/marketplace')}`}
          onClick={() => navigate('/marketplace')}
        >
          <i className="fas fa-store mr-2"></i> Marketplace
        </Button>
        
        {/* Advanced Property Search */}
        <Button
          variant="ghost"
          data-testid="nav-property-search"
          className={`whitespace-nowrap ${getActiveClass('/properties')}`}
          onClick={() => navigate('/properties')}
        >
          <i className="fas fa-search mr-2 text-emerald-600"></i> Find Properties
        </Button>
        
        {/* Home Services - Available to everyone */}
        <Button
          variant="ghost"
          data-testid="nav-home-services"
          className={`whitespace-nowrap ${getActiveClass('/home-services')}`}
          onClick={() => navigate('/home-services')}
        >
          <i className="fas fa-tools mr-2"></i> Home Services
        </Button>
        
        {isAgentOrOwner && (
          <>
            <Button
              variant="ghost"
              data-testid="nav-dashboard"
              className={`whitespace-nowrap ${getActiveClass('/dashboard')}`}
              onClick={() => navigate('/dashboard')}
            >
              <i className="fas fa-chart-line mr-2"></i> My Portal
            </Button>
            <Button
              variant="ghost"
              data-testid="nav-subscription"
              className={`whitespace-nowrap ${getActiveClass('/subscription')}`}
              onClick={() => navigate('/subscription')}
            >
              <i className="fas fa-crown mr-2"></i> Subscription
            </Button>
            <Button
              variant="ghost"
              data-testid="nav-new-listing"
              className={`whitespace-nowrap ${getActiveClass('/new-listing')}`}
              onClick={() => navigate('/new-listing')}
            >
              <i className="fas fa-plus-circle mr-2"></i> New Listing
            </Button>
            <Button
              variant="ghost"
              data-testid="nav-new-campaign"
              className={`whitespace-nowrap ${getActiveClass('/new-campaign')}`}
              onClick={() => navigate('/new-campaign')}
            >
              <i className="fas fa-bullhorn mr-2"></i> Launch Campaign
            </Button>
          </>
        )}
        
        {isInfluencer && (
          <Button
            variant="ghost"
            data-testid="nav-influencer-portal"
            className={`whitespace-nowrap ${getActiveClass('/influencer-portal')}`}
            onClick={() => navigate('/influencer-portal')}
          >
            <i className="fas fa-user-star mr-2"></i> Influencer Portal
          </Button>
        )}
        
        {isContractor && (
          <Button
            variant="ghost"
            data-testid="nav-contractor-dashboard"
            className={`whitespace-nowrap ${getActiveClass('/contractor/dashboard')}`}
            onClick={() => navigate('/contractor/dashboard')}
          >
            <i className="fas fa-hard-hat mr-2"></i> Contractor Portal
          </Button>
        )}
        
        <Button
          variant="ghost"
          data-testid="nav-bond-calculator"
          className={`whitespace-nowrap ${getActiveClass('/bond-calculator')}`}
          onClick={() => navigate('/bond-calculator')}
        >
          <i className="fas fa-calculator mr-2"></i> Bond Calculator
        </Button>
      </div>
    </nav>
  );
};

export default Navigation;